// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"794":"951eb1d0","946":"bc3302db","961":"11c30bcd"}[chunkId] + ".js";
};